import React, { PropsWithChildren } from 'react';
import styled from 'styled-components';
import Switch, { ISwitchOptions } from 'devextreme-react/switch';
import { color } from '@nuvolo/nuux-theme/utils';

const SwitchWrapper = styled.div`
  width: 92px;
  display: flex;
  align-items: center;
  margin: 16px 0 0 8px;

  .dx-switch-handle::before {
    position: relative;
    bottom: 2px;
    width: 24px;
    height: 24px;
    filter: drop-shadow(0px 1px 1px rgba(21, 25, 33, 0.5));
  }

  .dx-switch-container::before {
    background-color: ${color('custom', 'switchBackground')};
    width: 40px;
    height: 16px;
  }

  .dx-switch-on-value {
    .dx-switch-container::before {
      background-color: ${color('accent', 'light3')};
    }

    .dx-switch-handle::before {
      background-color: ${color('accent', 'middle')};
    }
  }
`;

const SelectLabel = styled.span`
  font-size: 14px;
  font-weight: 400;
  line-height: 100%;
  font-family: Mulish;
  margin-left: 16px;
  color: ${color('custom', 'contrastText')};
`;

export interface MobileSwitchProps extends ISwitchOptions {
  margin?: string;
  label?: string;
}

const MobileSwitch: React.FC<MobileSwitchProps> = ({ label = 'Select', margin, ...props }) => {
  return (
    <SwitchWrapper style={{ margin }}>
      <Switch {...props} />
      <SelectLabel>{label}</SelectLabel>
    </SwitchWrapper>
  );
};

export default React.memo(MobileSwitch);
